import { buildConfigSchema, BuildConfigSchema } from './schema';

// Default config for CI/build environments where build-config.json doesn't exist
const defaultConfig: BuildConfigSchema = {
  locales: [{ code: 'en', isDefault: true }],
  urls: {
    vanityUrl: '',
    checkoutUrl: '',
    cdnUrls: [],
  },
};

// Try to load the real config, fall back to defaults
let rawBuildConfig: BuildConfigSchema;
try {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  rawBuildConfig = require('./build-config.json') as BuildConfigSchema;
} catch {
  rawBuildConfig = defaultConfig;
}

class BuildConfig {
  private config = buildConfigSchema.parse(rawBuildConfig);

  get<K extends keyof BuildConfigSchema>(key: K): BuildConfigSchema[K] {
    if (key in this.config) {
      return this.config[key];
    }

    throw new Error(`Key "${key}" not found in BuildConfig`);
  }
}

export const buildConfig = new BuildConfig();
